import React, {useState} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ClockIcon from 'Components/common/Icons/ClockIcon';
import OpeningHours from 'Utils/OpeningHours';
import {ExpandLess, ExpandMore} from '@material-ui/icons';
import {IconButton} from '@material-ui/core';
import {filterFirstLast} from 'Utils/filterFirstLast';
import * as analytics from 'Utils/analytics';

const TenantInfoHours = ({
    infoHours,
    timeZone,
    showClock = true,
    isExpandable = true,
    analyticsExtraFields,
}) => {
    const [open, setOpen] = useState(false);

    const openingHours = new OpeningHours({osmOpeningHoursString: infoHours, timeZone});
    const table = openingHours.getTable();
    const statusLabel = openingHours.getStatusLabel();
    const statusActionLabel = openingHours.getStatusActionLabel();

    return (
        <div
            id="info-hours-001"
            className={classNames('info-hours', {collapsed: !open})}
            onClick={() => {
                if (isExpandable) {
                    if (!open) {
                        analytics.sendDirectoryEvent(
                            analytics.ACTIONS.TENANT,
                            'Expand',
                            analyticsExtraFields
                        );
                    }
                    setOpen(!open);
                }
            }}
        >
            <div className="info-hours-title">
                {showClock && <ClockIcon height="14" id="toggle-hours" width="14" />}

                {statusLabel && (
                    <div
                        className={classNames('label', 'display-label', {
                            'status-open': openingHours.getStatus() === 'open',
                            'status-nearly-open': openingHours.getStatus() === 'nearly-open',
                            'status-closed': openingHours.getStatus() === 'closed',
                            'status-nearly-closed': openingHours.getStatus() === 'nearly-closed',
                        })}
                    >
                        {openingHours.getStatusLabel()}
                    </div>
                )}
                {statusActionLabel && <p className="display-opening-time">{statusActionLabel}</p>}
                {isExpandable && (
                    <IconButton onClick={() => setOpen(!open)} size="small">
                        {open ? <ExpandLess /> : <ExpandMore />}
                    </IconButton>
                )}
            </div>
            <div className="info-hours-detail">
                <table>
                    <tbody>
                        {table.map(row => (
                            <tr key={row.dayOfWeek}>
                                <td>{row.dayOfWeek.filter(filterFirstLast).join(' - ')}</td>
                                <td>{row.open ? row.hours.join('; ') : 'Closed'}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

TenantInfoHours.propTypes = {
    isExpandable: PropTypes.bool,
    infoHours: PropTypes.string.isRequired,
    timeZone: PropTypes.string,
    showClock: PropTypes.bool,
    analyticsExtraFields: PropTypes.object,
};

export default TenantInfoHours;
